import { defineAsyncComponent } from 'vue'
export default {
  astrobot: defineAsyncComponent(() => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/layouts/astrobot.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/layouts/default.vue").then(m => m.default || m))
}